import React, {createContext, useContext} from 'react';
import PropTypes from 'prop-types';

const defaultValue = null;

const TextContext = createContext(defaultValue);

const TextContextProvider = ({children, values}) => {
  return <TextContext.Provider value={values}>{children}</TextContext.Provider>;
};

const TextContextConsumer = TextContext.Consumer;

function useText() {
  const context = useContext(TextContext);
  return context;
}

export {useText, TextContextProvider, TextContextConsumer};

TextContextProvider.defaultProps = {
  children: null,
  values: null,
};

TextContextProvider.propTypes = {
  children: PropTypes.node,
  values: PropTypes.shape({}),
};
